import React, { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePostRequest } from '../../service/PostTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import { endPoints } from '../../Config';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';

const AddEditInvoiceManagement = ({ editable, viewable, onHide, rowRecord, onClose }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [customersData, setCustomersData] = useState([]);

    const user = JSON.parse(localStorage.getItem('adminUser') || '{}');

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        customerId: Yup.string().required('This field is required'),
        name: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Name must contain only alphanumeric values'),
        purpose: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),
        amount: Yup.string()
            .matches(/^\d+$/, 'Amount should only contain numbers')
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),
        dueDate: Yup.string().required('This field is required'),
        amountAfterDueDate: Yup.string()
            .matches(/^\d+$/, 'Amount should only contain numbers')
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),
        phoneNumber: Yup.string()
            .matches(/^\d+$/, 'Phone number should only contain numbers')
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
    });
    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            id: '',
            customerId: '',
            purpose: '',
            amount: '',
            dueDate: '',
            amountAfterDueDate: '',
            name: '',
            phoneNumber: '',
            createdAt: '',
            modifiedAt: '',
            modifiedBy: '',
            deletedAt: '',
            deletedBy: '',
            createdBy: ''
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);
            const addData = {
                customerId: data.customerId,
                purpose: data.purpose,
                amount: data.amount,
                dueDate: data.dueDate,
                amountAfterDueDate: data.amountAfterDueDate,
                name: data.name,
                phone: data.phoneNumber,
                createdBy: user?.data?.userId
            };

            const editData = {
                id: data.id,
                customerId: data.customerId,
                purpose: data.purpose,
                amount: data.amount,
                dueDate: data.dueDate,
                amountAfterDueDate: data.amountAfterDueDate,
                name: data.name,
                phone: data.phoneNumber,
                createdBy: user?.data?.userId,
                modifiedBy: user?.data?.userId
            };

            if (!editable) {
                const response = await dispatch(handlePostRequest(addData, endPoints.addInvoice, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            } else {
                const response = await dispatch(handlePutRequest(editData, endPoints.updateInvoice, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            }
        }
    });

    const getInvoiceById = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getInvoiceById(rowRecord.id), true);
        if (response) {
            const dateformat = response?.data?.dueDate ? formatedDate(response?.data?.dueDate) : '';
            formik.setFieldValue('dueDate', dateformat);
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('status', response?.data?.status);
            formik.setFieldValue('name', response?.data?.name);
            formik.setFieldValue('amount', response?.data?.amount);
            formik.setFieldValue('phoneNumber', response?.data?.phone);
            formik.setFieldValue('customerId', response?.data?.customerId);
            formik.setFieldValue('purpose', response?.data?.purpose);
            formik.setFieldValue('amountAfterDueDate', response?.data?.amountAfterDueDate);
        }
        setLoadingBtn(false);
    };
    const getCustomersDropdown = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getDropdownCustomers, true);
        setCustomersData(response?.data);

        setLoadingBtn(false);
    };
    useEffect(() => {
        if (editable || viewable) {
            getInvoiceById();
        }
    }, [rowRecord]);

    useEffect(() => {
        getCustomersDropdown();
    }, []);

    function formatedDate(originalDate) {
        const createDate = new Date(originalDate);

        const year = createDate.getFullYear();
        const month = (createDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
        const day = createDate.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="customerId">
                            Customer <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            id="customerId"
                            name="customerId"
                            value={formik?.values?.customerId}
                            options={customersData}
                            optionLabel="name"
                            optionValue="id"
                            onChange={formik.handleChange}
                            placeholder="Select Customer"
                            className="w-full"
                            disabled={viewable}
                        />
                        {formik.touched.customerId && formik.errors.customerId && <small className="p-error">{formik.errors.customerId}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="name">
                            Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="name" name="name" placeholder="Enter name" value={formik?.values?.name} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="purpose">
                            Purpose <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="purpose" name="purpose" placeholder="Enter Purpose" value={formik?.values?.purpose} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.purpose && formik.errors.purpose && <small className="p-error">{formik.errors.purpose}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="amount">
                            Amount <span style={{ color: 'red' }}>*</span>{' '}
                        </label>
                        <InputText id="amount" name="amount" placeholder="Enter Amount." value={formik?.values?.amount} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.amount && formik.errors.amount && <small className="p-error">{formik.errors.amount}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="dueDate">
                            {' '}
                            Due Date <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="dueDate" type="date" name="dueDate" max={previousDate} value={formik?.values?.dueDate || ''} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.dueDate && formik.errors.dueDate && <small className="p-error">{formik.errors.dueDate}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="amountAfterDueDate">
                            Amount After Due Date <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="amountAfterDueDate" name="amountAfterDueDate" placeholder="Enter Amount After Due Date" value={formik?.values?.amountAfterDueDate} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.amountAfterDueDate && formik.errors.amountAfterDueDate && <small className="p-error">{formik.errors.amountAfterDueDate}</small>}
                    </div>
                </div>

                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="phoneNumber">
                            Phone No. <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="phoneNumber" name="phoneNumber" placeholder="Enter Phone Number" value={formik?.values?.phoneNumber} maxLength={11} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.phoneNumber && formik.errors.phoneNumber && <small className="p-error">{formik.errors.phoneNumber}</small>}
                    </div>
                </div>
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                {!viewable && (
                    <Button label={editable ? 'Update' : 'Save'} icon={editable ? 'pi pi-pencil' : 'pi pi-save'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                )}
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onClose()} />
            </div>
        </form>
    );
};

export default AddEditInvoiceManagement;
